// extracted by mini-css-extract-plugin
export default {"root":"ForbiddenErrorPage__root___ICsmD","logout":"ForbiddenErrorPage__logout___H6Cml"};